var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRestrictedLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8 1a7 7 0 015.052 11.845l.251.251-.707.707-.286-.287A7 7 0 118 1zM2 8a6 6 0 009.597 4.803l-8.4-8.4A5.973 5.973 0 002 8zm6-6c-1.604 0-3.061.63-4.138 1.655l8.483 8.483A6 6 0 008 2z"
  }))));
}

export default __webpack_public_path__ + "4728f18d9f154dd66939492c45f47eba.svg";
export { SvgIconRestrictedLight as ReactComponent };